import homeProgress0 from 'url:../../../assets/images/home-progress-0.webp';
import sideLungesVideo from 'url:../../../assets/videos/side-lunges.mp4';
import lunges1 from 'url:../../../assets/images/lunges-1.webp';
import lunges2 from 'url:../../../assets/images/side-lunges-2.webp';

export const sideLungesAssets = {
  homeProgress0,
  sideLungesVideo,
  lunges1,
  lunges2,
} as const;

export const sideLungesAssetList = Object.values(sideLungesAssets);
